var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.243,
    height: 83.752,
    viewBox: "0 0 70.243 83.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(-248 -833.519)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(257 857.481)",
    fill: "#9e2ffb",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("g", {
    id: "pharmacy_2_",
    "data-name": "pharmacy (2)",
    transform: "translate(206.708 833.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548",
    transform: "translate(41.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M77.833,0H48.84a7.556,7.556,0,0,0-7.548,7.547v53.42a7.556,7.556,0,0,0,7.548,7.548H68.457a1.227,1.227,0,1,0,0-2.454H48.84a5.1,5.1,0,0,1-5.094-5.094V7.547A5.1,5.1,0,0,1,48.84,2.454h2.716V5.125A5.577,5.577,0,0,0,57.127,10.7h.865a1.227,1.227,0,1,0,0-2.454h-.865A3.121,3.121,0,0,1,54.01,5.125V2.454H72.663V5.125a3.121,3.121,0,0,1-3.117,3.117H63.239a1.227,1.227,0,1,0,0,2.454h6.307a5.577,5.577,0,0,0,5.571-5.571V2.454h2.717a5.1,5.1,0,0,1,5.094,5.094V24.995a1.227,1.227,0,1,0,2.454,0V7.547A7.556,7.556,0,0,0,77.833,0Z",
    transform: "translate(-41.292 0)",
    fill: "#504b5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550",
    transform: "translate(54.983 60.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M133.735,369.858h-7.519a1.227,1.227,0,0,0,0,2.454h7.519a1.227,1.227,0,0,0,0-2.454Z",
    transform: "translate(-124.989 -369.858)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(67.257 28.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M239.266,191.759a5.02,5.02,0,0,0-3.524,1.441,5.031,5.031,0,0,0-7.677-.612,5.031,5.031,0,0,0-6.624-1.318V180.337a5.037,5.037,0,0,0-10.074,0v23.616l-2.18-2.18a5.366,5.366,0,0,0-7.589,7.589l13.58,13.58v6.208a1.227,1.227,0,0,0,1.227,1.227h3.157a1.227,1.227,0,1,0,0-2.454h-1.93v-5.49a1.227,1.227,0,0,0-.359-.867l-13.939-13.939a2.913,2.913,0,0,1,4.119-4.119l4.275,4.274a1.227,1.227,0,0,0,2.094-.867V180.337a2.584,2.584,0,1,1,5.167,0v15.255a1.227,1.227,0,0,0,2.454,0,2.584,2.584,0,1,1,5.167,0v.535a1.227,1.227,0,0,0,2.454,0,2.584,2.584,0,1,1,5.167,0v.669a1.227,1.227,0,0,0,2.454,0,2.584,2.584,0,1,1,5.167,0v31.127H224.792a1.227,1.227,0,0,0,0,2.454h18.284a1.227,1.227,0,0,0,1.227-1.227V196.8A5.043,5.043,0,0,0,239.266,191.759Z",
    transform: "translate(-200.025 -175.3)",
    fill: "#504b5f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.96dc7b11df7103a8b2f2b4702ca751fb.svg";
export { ForwardRef as ReactComponent };